import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@mantine/core';
import { MeasurementListEntry } from './measurementListEntry';
import { useReportsStore } from '../../reports/stores';
import { useKeycloakStore } from '../../../shared_stores';
import { LoadingElement } from '../../../shared_components';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

export const PrevMeasurementsList = observer(() => {
  const { t } = useTranslation(['common', 'reports']);
  const navigate = useNavigate();
  const reportsStore = useReportsStore();
  const kcStore = useKeycloakStore();
  const measurements = reportsStore.measurements
    ?.slice()
    .reverse()
    .map((entry) => {
      return {
        id: entry.id,
        date: new Date(entry.timestamp),
        location: 'Combyn Test Device',
      };
    });

  if (!reportsStore.loadedMeasurementList) {
    void reportsStore.loadMeasurementList(kcStore.token);
    return <LoadingElement />;
  }

  const list = measurements?.map((entry, index) => {
    const addYear = () => {
      if (index === 0) {
        return <Text>{t('reports:this_year')}</Text>;
      } else {
        if (
          entry.date.getFullYear() < measurements[index - 1].date.getFullYear()
        ) {
          return <Text>{entry.date.getFullYear()}</Text>;
        }
      }
    };

    return (
      <>
        {addYear()}
        <MeasurementListEntry
          location={entry.location}
          date={entry.date}
          onClick={() => void navigate(`/reports/overview?id=${entry.id}`)}
        />
      </>
    );
  });

  return <Stack>{list}</Stack>;
});
